import React, { useEffect } from "react";

import { ICardProps } from "../../CreditCard/types";
import usePayment from "hooks/usePayment";
import { Currency } from "components";

import * as S from "../../CreditCard/styles";
import { useFormContext } from "react-hook-form";

interface PropsPixMethod {
  is2MethodsChildren: boolean
}

export const PixMethod: React.FC<ICardProps & PropsPixMethod> = ({ enable, is2MethodsChildren }) => {
  const { setPaymentCard, paymentCard } = usePayment();

  const { control, formState: { errors } } = useFormContext()

  return (
    <S.Container enable={enable} style={{ borderRadius: "0px 0px 8px 8px", overflow: "hidden" }}>
      <S.Row>
        <S.WrapperRight active={enable}>
          <S.WrapperHeader>
            <S.Title>Pix</S.Title>
          </S.WrapperHeader>

          <S.RowInputs style={{ marginBottom: "8px" }}>
            <S.WrapperInput>
              <Currency
                type="text"
                type_input="normal"
                placeholder="Valor para pagar no cartão"
                onChange={(e: any) => {
                  setPaymentCard({
                    ...paymentCard,
                    value: e.target.value,
                  })
                }
                }
                name="value"
                disabled={!is2MethodsChildren}
                control={control}
                error={errors?.value?.message as string}
              />
            </S.WrapperInput>
            <S.MarginInputs />
          </S.RowInputs>
        </S.WrapperRight>
      </S.Row>
    </S.Container>
  );
};
